export default __webpack_public_path__ + "static/media/ies_DanielaViloria.4bebcb23.png";